import { createReducer, on } from '@ngrx/store';
import * as crmActions from '../../actions/crm/crm.actions';

export const crmFeatureKey = 'crm';

export interface State {
  offers: any;
  selectedCRMOffer: any;
  countMessages: number;
}

export const initialState: State = {
  offers: {},
  selectedCRMOffer: {},
  countMessages: 0
};

export const reducer = createReducer(
  initialState,
  on(crmActions.getCRMOffersSuccess, (state, action) => {
    return {
      ...state,
      offers: action.offers
    };
  }),
  on(crmActions.selectActiveCRMOffer, (state, action) => {
    return {
      ...state,
      selectedCRMOffer: action
    };
  }),
  on(crmActions.countCRMOffersSuccess, (state, { count }) => ({
    ...state,
    countMessages: count,
    error: null
  })),
  on(crmActions.countCRMOffersFailure, (state, { error }) => ({
    ...state,
    error
  }))
);
